import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import s from './Toolbar.scss';
import Text from '../Text';
export var Toolbar = function Toolbar(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: s.toolbar
  }, props.children);
};
Toolbar.displayName = 'Toolbar';
Toolbar.propTypes = {
  children: PropTypes.any // TODO: validate children are of type <ItemGroup>

};
export var ItemGroup = function ItemGroup(props) {
  var classes = classNames([s.itemGroup, {
    positionStart: props.position === 'start',
    positionEnd: props.position === 'end'
  }]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes
  }, props.children);
};
ItemGroup.displayName = 'Toolbar.ItemGroup';
ItemGroup.propTypes = {
  children: PropTypes.any,
  // TODO: validate children are either <Item> od <Divider>
  position: PropTypes.oneOf(['start', 'end'])
};
ItemGroup.defaultProps = {
  position: 'start'
};
export var Item = function Item(props) {
  var classes = classNames([s.item, _defineProperty({}, s.layoutButton, props.layout === 'button')]);
  return /*#__PURE__*/React.createElement("span", {
    className: classes
  }, props.children);
};
Item.displayName = 'Toolbar.Item';
Item.propTypes = {
  children: PropTypes.any,
  layout: PropTypes.oneOf(['button'])
};
/**
 * Similar to the original WSR Label, but the label is displayed on the same line as the target element (and not above it).
 * TODO:; we might want to simply add this ability to the existing Label.
 */

export var Label = function Label(props) {
  return /*#__PURE__*/React.createElement(Text, _extends({
    tagName: "label"
  }, props, {
    className: s.itemLabel
  }), React.Children.toArray(props.children).map(function (c, index) {
    return typeof c === 'string' ? /*#__PURE__*/React.createElement("span", {
      key: index
    }, c) : c;
  }));
};
Label.displayName = 'Toolbar.Label';
Label.propTypes = {
  children: PropTypes.any
};
export var Divider = function Divider() {
  return /*#__PURE__*/React.createElement("span", {
    className: s.divider
  });
};
Divider.displayName = 'Toolbar.Divider'; // Aliases for convenience

Toolbar.ItemGroup = ItemGroup;
Toolbar.Item = Item;
Toolbar.Label = Label;
Toolbar.Divider = Divider;